import Vuex from "vuex";
import Vue from "vue";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import createManagementStore from "@shared/createManagementStore.cjs";

export default createManagementStore({
  Framework: Vue,
  StoreLibrary: Vuex,
  state,
  mutations,
  actions,
  storage: localStorage,
});
